import { readPlatformSessionIdFromPageEntry } from '@/common/utils/platformFileSession'
import { normalizePlatformSessionId } from '@/common/utils/jsRequestSessionContext'

export type ReloadPanelSessionContext = {
  sessionId?: string | number | null
  eventCoreId?: string | number | null
}

/**
 * sessionId для reload/panel: актуальный pagesData > context.sessionId.
 * eventCoreId из WS НЕ ИСПОЛЬЗУЕТСЯ - он часто указывает на уничтоженный auxiliary core после killDraft.
 * Swing parity: Swing использует action.getCore() (main session), не eventCoreId из WS.
 */
export function resolveReloadPanelSessionId(
  context: ReloadPanelSessionContext | undefined | null,
  pageEntries: unknown[],
  isSessionClosing?: (sessionId: string) => boolean,
): string | null {
  for (const entry of pageEntries) {
    const fromHelper = readPlatformSessionIdFromPageEntry(entry)
    if (fromHelper) return fromHelper
    const direct = normalizePlatformSessionId((entry as { sessionId?: unknown } | null)?.sessionId)
    if (direct) return direct
  }

  const fromContext = normalizePlatformSessionId(context?.sessionId)
  if (fromContext) return fromContext

  // eventCoreId НЕ ИСПОЛЬЗУЕТСЯ как fallback - это auxiliary sessionId который может быть закрыт
  // Swing: всегда использует main core, не auxiliary core из WS события
  return null
}
